import Vue from 'vue'
import Router from 'vue-router'
import TokenRedirect from "@/components/TokenRedirect";
import TheContainer from '@/container/TheContainer.vue';
import Login from "@/views/Login.vue";
import Dashboard from "@/views/Dashboard.vue";
import Accounts from '@/views/Accounts.vue';
import AccountsView from "@/views/Accounts/AccountsView.vue";
import Organization from "@/views/Organization.vue"
import Task from "@/views/Task.vue"
import Leads from "@/views/Leads.vue";
import Resumes from "@/views/Resumes.vue";
import Candidates from "@/views/Candidates.vue";
import Search from "@/views/Search.vue";
import Profile from "@/views/Profile.vue";
import Reports from "@/views/Reports.vue";
import Pitch from "@/views/Pitch.vue";
import Assignment from "@/views/Assignment.vue";
import crmLoader from "@/views/crmLoader.vue";

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/crm/:site_token?/:crm_token?',
            name: 'crm_init',
            component: crmLoader
        },
        {
            path: '/',
            name: 'mani-container',
            component: TheContainer,
            children: [{
                    path: '/',
                    name: 'dashboard',
                    component: Dashboard,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/organization/:type?',
                    name: 'organization',
                    component: Organization,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/organization/consultants/:id/:company_id',
                    name: 'manage_consultant',
                    component: Organization,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/organization/teams/:team_id',
                    name: 'view-team',
                    component: Organization,
                    meta: {
                        requiresAuth: true,
                    }
                },

                {
                    path: '/accounts/:type?/:id?',
                    name: 'accounts',
                    component: Accounts,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/task/:id?',
                    name: 'task',
                    component: Task,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/leads/:id?',
                    name: 'leads',
                    component: Leads,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/candidates/:id?',
                    name: 'candidates',
                    component: Candidates,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/resumes/:type?',
                    name: 'resumes',
                    component: Resumes,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/pitch/',
                    name: 'pitch',
                    component: Pitch,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/accounts/view/:type/:id',
                    name: 'account-view',
                    component: AccountsView,
                    meta: {
                        requiresAuth: true,
                    }
                },

                {
                    path: '/assignment',
                    name: 'assignment',
                    component: Assignment,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/search',
                    name: 'search',
                    component: Search,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/profile/:type?',
                    name: 'profile',
                    component: Profile,
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/reports/:type?',
                    name: 'reports',
                    component: Reports,
                    meta: {
                        requiresAuth: true,
                    }
                }

            ]
        },
        {
            path: '/social-login/:provider/:id',
            name: 'log-token',
            component: TokenRedirect
        },
        {
            path: '*',
            redirect: '/page-not-found'
        },
    ]
})